import { Label } from '../../labels';
import { RoutineType } from '../../graphql';

export interface RoutineConfig {
  title: string;
  routineButtonText?: string;
  issuePrefix?: string;
  reportOnException?: boolean;
  inventory?: boolean;
  uom?: string;
  autoLabels?: Label[];
}

export interface SingleStateConfig extends RoutineConfig {
  instructions: string;
}

/**
 * Determines whether draft functionality should be enabled for a given routine type.
 * Drafts are only enabled for Workflow routines (mini forms).
 * Counter, QuickConfirm, and Status routines should not have draft functionality.
 * 
 * @param routineType - The type of routine to check
 * @returns true if drafts should be enabled, false otherwise
 */
export function isDraftEnabledForRoutineType(routineType?: RoutineType): boolean {
  // Only enable drafts for Workflow routines
  return routineType === RoutineType.Workflow;
}
